import React, { Component } from "react";
import "w3-css/3/w3.css";

class FromDayButton extends Component {
  handleClickButon = buttonId => {
    this.props.daUnit(buttonId);
  };
  render() {
    return (
      <div className="w3-margin-small w3-padding-small w3-white">
        <h3>From Day to </h3>
        <div className="w3-container">
          <div className="w3-margin">
            <p>
              <HourButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <MinuteButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <MonthButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <SecondButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <WeekButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <YearButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
            </p>
          </div>
        </div>
      </div>
    );
  }
}

class FromHourButton extends Component {
  handleClickButon = buttonId => {
    this.props.hrUnit(buttonId);
  };
  render() {
    return (
      <div className="w3-margin-small w3-padding-small w3-white">
        <h3>From Hour to </h3>
        <div className="w3-container">
          <div className="w3-margin">
            <p>
              <DayButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <MinuteButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <MonthButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <SecondButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <WeekButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <YearButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
            </p>
          </div>
        </div>
      </div>
    );
  }
}

class FromMinuteButton extends Component {
  handleClickButon = buttonId => {
    this.props.mnUnit(buttonId);
  };
  render() {
    return (
      <div className="w3-margin-small w3-padding-small w3-white">
        <h3>From Minute to </h3>
        <div className="w3-container">
          <div className="w3-margin">
            <p>
              <DayButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <HourButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <MonthButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <SecondButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <WeekButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <YearButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
            </p>
          </div>
        </div>
      </div>
    );
  }
}

class FromMonthButton extends Component {
  handleClickButon = buttonId => {
    this.props.moUnit(buttonId);
  };
  render() {
    return (
      <div className="w3-margin-small w3-padding-small w3-white">
        <h3>From Gregorian Month to </h3>
        <div className="w3-container">
          <div className="w3-margin">
            <p>
              <DayButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <HourButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <MinuteButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <SecondButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <WeekButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <YearButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
            </p>
          </div>
        </div>
      </div>
    );
  }
}

class FromSecondButton extends Component {
  handleClickButon = buttonId => {
    this.props.sdUnit(buttonId);
  };
  render() {
    return (
      <div className="w3-margin-small w3-padding-small w3-white">
        <h3>From Second to </h3>
        <div className="w3-container">
          <div className="w3-margin">
            <p>
              <DayButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <HourButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <MinuteButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <MonthButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <WeekButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <YearButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
            </p>
          </div>
        </div>
      </div>
    );
  }
}

class FromWeekButton extends Component {
  handleClickButon = buttonId => {
    this.props.wkUnit(buttonId);
  };
  render() {
    return (
      <div className="w3-margin-small w3-padding-small w3-white">
        <h3>From Week to </h3>
        <div className="w3-container">
          <div className="w3-margin">
            <p>
              <DayButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <HourButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <MinuteButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <MonthButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <SecondButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <YearButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
            </p>
          </div>
        </div>
      </div>
    );
  }
}

class FromYearButton extends Component {
  handleClickButon = buttonId => {
    this.props.yrUnit(buttonId);
  };
  render() {
    return (
      <div className="w3-margin-small w3-padding-small w3-white">
        <h3>From Gregorian Year to </h3>
        <div className="w3-container">
          <div className="w3-margin">
            <p>
              <DayButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <HourButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <MinuteButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <MonthButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <SecondButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <WeekButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
            </p>
          </div>
        </div>
      </div>
    );
  }
}

class DayButton extends Component {
  handleUpButton = () => {
    let name = "da";
    this.props.clickedbutton(this.props.id + name);
  };
  render() {
    return (
      <span className="w3-tag w3-white w3-large w3-margin-bottom">
        <button
          className="w3-btn w3-light-grey"
          onClick={this.handleUpButton}
          name="day"
        >
          Days
        </button>
      </span>
    );
  }
}

class HourButton extends Component {
  handleUpButton = () => {
    let name = "hr";
    this.props.clickedbutton(this.props.id + name);
  };
  render() {
    return (
      <span className="w3-tag w3-white w3-large w3-margin-bottom">
        <button
          className="w3-btn w3-light-grey"
          onClick={this.handleUpButton}
          name="hour"
        >
          Hours
        </button>
      </span>
    );
  }
}

class MinuteButton extends Component {
  handleUpButton = () => {
    let name = "mn";
    this.props.clickedbutton(this.props.id + name);
  };
  render() {
    return (
      <span className="w3-tag w3-white w3-large w3-margin-bottom">
        <button
          className="w3-btn w3-light-grey"
          onClick={this.handleUpButton}
          name="minute"
        >
          Minutes
        </button>
      </span>
    );
  }
}

class MonthButton extends Component {
  handleUpButton = () => {
    let name = "mo";
    this.props.clickedbutton(this.props.id + name);
  };
  render() {
    return (
      <span className="w3-tag w3-white w3-large w3-margin-bottom">
        <button
          className="w3-btn w3-light-grey"
          onClick={this.handleUpButton}
          name="month"
        >
          Gregorian Months
        </button>
      </span>
    );
  }
}

class SecondButton extends Component {
  handleUpButton = () => {
    let name = "sd";
    this.props.clickedbutton(this.props.id + name);
  };
  render() {
    return (
      <span className="w3-tag w3-white w3-large w3-margin-bottom">
        <button
          className="w3-btn w3-light-grey"
          onClick={this.handleUpButton}
          name="second"
        >
          Seconds
        </button>
      </span>
    );
  }
}

class WeekButton extends Component {
  handleUpButton = () => {
    let name = "wk";
    this.props.clickedbutton(this.props.id + name);
  };
  render() {
    return (
      <span className="w3-tag w3-white w3-large w3-margin-bottom">
        <button
          className="w3-btn w3-light-grey"
          onClick={this.handleUpButton}
          name="week"
        >
          Weeks
        </button>
      </span>
    );
  }
}

class YearButton extends Component {
  handleUpButton = () => {
    let name = "yr";
    this.props.clickedbutton(this.props.id + name);
  };
  render() {
    return (
      <span className="w3-tag w3-white w3-large w3-margin-bottom">
        <button
          className="w3-btn w3-light-grey"
          onClick={this.handleUpButton}
          name="year"
        >
          Gregorian Years
        </button>
      </span>
    );
  }
}

export {
  FromDayButton,
  FromHourButton,
  FromMinuteButton,
  FromMonthButton,
  FromSecondButton,
  FromWeekButton,
  FromYearButton
};
